import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { Router } from '@angular/router';
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';

@Component({
  selector: 'app-extra-detail',
  templateUrl: './extra-detail.component.html',
  styleUrls: ['./extra-detail.component.scss']
})
export class ExtraDetailComponent implements OnInit {
  @Input() extraTimeRuleId: number
  button = {}
  DetailsDataSource: any = [];
  extratimeform: any = {}
  durationType: {}[] = [];
  typeStatus: {}[] = [];
  TaxableStatus: {}[] = []
  InsuranceStatus: {}[] = []
  extra_id: number;
  buttonOptions = {
    text: this.translate.instant('employeeduration.submit'),
    type: 'default',
    useSubmitBehavior: true,
  };
  addpopup: string = '';

  // loading
  loading:boolean=false

  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang: any;

  @Output() addnewdetails = new EventEmitter<boolean>(false)
  constructor(public gt: genericCustomStoreService, public Objects: ObjectsService,public NotifyService:NotifyService,
    public _publicSettingService:publicSettingService,
  public translate: TranslateService,public router:Router) {
    this.button = Objects.button;
    //get dropdown
    this.TaxableStatus = Objects.TaxableStatus;
    this.InsuranceStatus = Objects.InsuranceStatus
     this.gt.getdropdowndata("DelayRule/GetDropDown","RuleDuration").subscribe((data: {}[]) => {this.durationType = data})
     this.gt.getdropdowndata("DelayRule/GetDropDown","MinuteRulesTypes").subscribe((data: {}[]) => {this.typeStatus = data})
    this._publicSettingService.$ETRRA_TIME.subscribe((res: number) => {
      this.extra_id = res
      if (this.extra_id!= 0) {
        this.loading=true;
        this._publicSettingService.byKey('ExtraTimeRule',this.extra_id).subscribe((res: { extraTimeRuleDetails: [] }) => {
          this.extratimeform = res
          this.DetailsDataSource = res?.extraTimeRuleDetails

          this.loading=false;
        })
      }
      else {
        this.DetailsDataSource = []
      }
    })


    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );

    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
  });
  }

  ngOnInit(): void {
    this.extratimeform.dateOfRegistration = new Date()
  }

  onInitNewRow(e: any) {
    e.data.extraTimeRuleId = this.extra_id
    this.addpopup = this.translate.instant('tableinfo.addbutton')

  }
  onEditingStart() {
    this.addpopup = this.translate.instant('tableinfo.editbutton')

  }

  onFormSubmit(e: Event) {
    e.preventDefault();
    this.extratimeform.extraTimeRuleDetails = this.DetailsDataSource
    if (this.extra_id != 0) {
      this._publicSettingService.update('ExtraTimeRule',this.extratimeform).subscribe(res=>{
        this.NotifyService.notifyfun('edit')
        this.router.navigate(['hr/ExtraTimeRules'])
      })
    }

    else {
      this._publicSettingService.add('ExtraTimeRule',this.extratimeform).subscribe(res=>{
        this.NotifyService.notifyfun('add')
        this.router.navigate(['hr/ExtraTimeRules'])
      })
    }
  }

  // backToMainPage(e:string){
  //   if(e=='back'){
  //     this.router.navigate(['/hr/ExtraTimeRules'])
  //   }
  // }
  
  addrowfun(name: string) {
    return this.gt.addrow(name)
  }

}
